import styles from './Tab.module.scss';
import Box from '@components/Box';
import cn from 'classnames';
import ColumnList from '../components/СolumnList.tsx';
import DataTable, { DataViewHandle } from '@containers/DataTable';
import { AddSellerPanel } from '@components/AddSeller';
import { FilterModel } from '@hooks/useFiltersSearchParams';
import { Filters, FilterTypes } from '@containers/Filters';
import { getComplete, TCompleteParcel } from '@api/apiClient/dropshipping';
import { ICompleteTabProps } from '../types';
import { Row, Column } from '@components/Grid';
import { TableColumn, TableRowType } from '@components/Table/TableTypes';
import { useSellersCounter } from '@contexts/SellersCounterContext';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const CompleteTab = (props: ICompleteTabProps) => {
  const {
    isFilterOpen,
    setIsFilterOpen
  } = props;

  const [innerFilters, setInnerFilters] = useState<FilterModel[]>([]);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  const dataRef = useRef<DataViewHandle>(null);
  const { sellersNotFound } = useSellersCounter();
  const { t } = useTranslation();

  const columns: TableColumn<TCompleteParcel>[] = [
    {
      header: <div className={styles.columnList}>
        <span className={styles.columnListText}>{t('dropshipping.completeTab.trackNumber')}</span>
        <span className={styles.columnListText}/>
        <span className={styles.columnListText}>{t('dropshipping.completeTab.name')}</span>
        <span className={styles.columnListText}>{t('dropshipping.completeTab.orderNumberOzon')}</span>
        <span className={styles.columnListText}>{t('dropshipping.completeTab.otherMarketplaceNumber')}</span>
        <span className={styles.columnListText}>{t('dropshipping.completeTab.commentToWarehouse')}</span>
        <span className={styles.columnListText}>{t('dropshipping.completeTab.seller')}</span>
        <span className={styles.columnListText}>{t('dropshipping.completeTab.connectionDate')}</span>
      </div>,
      accessor: (row: TableRowType<TCompleteParcel>) => (
          <ColumnList
              calledFrom="complete"
              data={row.data}
          />
      ),
      noOverflow: true
    }
  ];

  if (sellersNotFound) {
    return (
        <AddSellerPanel
            isFirstSeller
            isOzonSeller
        />
    );
  }

  return (
      <>
        <Box
            pb={5}
            className={cn(!isFilterOpen && styles.hidden)}
        >
          <Column phone={12}>
            <Row
                justify="right"
                gap={5}
            >
              <Filters
                  id="dropshipping-complete"
                  openFilters={() => setIsFilterOpen(true)}
                  items={[
                    {
                      name: 'ExternalIds',
                      type: FilterTypes.MULTI_SEARCH,
                      placeholder: t('dropshipping.completeTab.orderNumberOzon')
                    },
                    {
                      name: 'ExternalMarketplaceTrackNumbers',
                      type: FilterTypes.MULTI_SEARCH,
                      placeholder: t('dropshipping.completeTab.otherMarketplaceNumber')
                    },
                    {
                      name: 'MatchingTrackNumbers',
                      type: FilterTypes.MULTI_SEARCH,
                      placeholder: t('dropshipping.completeTab.matchingTrackNumbers')
                    },
                    {
                      name: 'sellerIds',
                      type: FilterTypes.SELLER
                    },
                    {
                      name: 'dateRange',
                      type: FilterTypes.DATE_RANGE,
                      placeholder: t('dropshipping.completeTab.connectionDate'),
                      fieldNames: ['startDate', 'endDate']
                    }
                  ]}
                  onChange={(v, isReady) => {
                    if (isReady) {
                      setIsInitialized(true);
                    }
                    setInnerFilters(v);
                  }}
                  values={innerFilters}
                  asPanel
              />
            </Row>
          </Column>
        </Box>
        <DataTable<TCompleteParcel>
            columns={columns}
            dataRef={dataRef}
            defaultPageSize={10}
            filters={innerFilters}
            getData={getComplete}
            notFound={t('dropshipping.noParcels')}
            pending={!isInitialized}
            queryKey="dropshippingCompleteParcels"
        />
      </>
  );
};

export default CompleteTab;
